import React from 'react';
import Icon from '../icon/Icon';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
export const ButtonNavigation = (props) => {
    const { t } = useTranslation();
    const labelMap = {
        next: t('carousel.nextslidemessage'),
        prev: t('carousel.prevslidemessage'),
    };
    const textMap = {
        next: t('label.next'),
        prev: t('label.prev'),
    };
    const iconMap = {
        next: 'right-chevron',
        prev: 'left-chevron',
    };
    return (React.createElement("button", { className: `button button-navigation--${props.type} ${props.id}-navigation--${props.type}`, "aria-label": labelMap[props.type] }, props.isExtended ? (React.createElement(React.Fragment, null,
        props.type === 'prev' && '<',
        React.createElement("span", null, textMap[props.type]),
        props.type === 'next' && '>')) : (React.createElement(React.Fragment, null,
        React.createElement(Icon, { name: iconMap[props.type], family: "10" })))));
};
const CarouselNavigation = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classNames(`navigation ${props.id}-navigation`, { inverted: props.inverted }, { opacityOnDisabled: props.opacityOnDisable }, { 'justify-end': props.right }) }, props === null || props === void 0 ? void 0 :
            props.prevContent,
            React.createElement(ButtonNavigation, { id: props.id, type: "prev", isExtended: props.isExtended }),
            React.createElement(ButtonNavigation, { id: props.id, type: "next", isExtended: props.isExtended }), props === null || props === void 0 ? void 0 :
            props.nextContent)));
};
CarouselNavigation.defaultProps = {
    opacityOnDisable: true,
};
export default CarouselNavigation;
